/* eslint-disable jsx-a11y/media-has-caption */
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { COLOR_BLACK } from "@static/COLORS";
const { REACT_APP_API_ENDPOINT } = process.env;

const Container = styled.div`
  width: ${({ width = 1920 }) => width}px;
  height: ${({ height = 1080 }) => height}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Video = ({
  attribute,
  mute = false,
  controls = false,
  width,
  height,
}) => {
  const path = `${REACT_APP_API_ENDPOINT}/${_.get(attribute, ["path"])}`;
  const objectFit = _.get(attribute, ["objectFit"], "fill");
  return (
    <Container width={width} height={height}>
      <video
        src={path}
        autoPlay
        loop
        muted={mute}
        controls={controls}
        style={{
          width: "100%",
          height: "100%",
          objectFit,
          background: COLOR_BLACK,
        }}
      ></video>
    </Container>
  );
};
